import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class AccountSearchInputService {
    private _title: string;

    clearSearch = new EventEmitter<string>();
}
